import { useEffect } from 'react';
import { MessageEventsEnum } from '../types/events/message-events.enum.ts';
import { store, useAppSelector } from '../store';
import { rawApp } from '../store/app/app.raw.ts';

export const useListenAppsMessages = () => {
    const activeAccount = useAppSelector((state) => state.app.activeAccount);
    const lang = useAppSelector((state) => state.app?.settings?.lang);

    const sendPayloadData = (sourceWindow?: Window) => {
        const user = store.getState().user;
        const lang = store.getState().app?.settings?.lang;
        const connectionId = store.getState().app?.connectionId;

        const message = { lang, connectionId, user: user ? { id: user.id } : null };

        if (sourceWindow) return sourceWindow.postMessage(message, '*');

        const iframes = document.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
            iframe.contentWindow?.postMessage(message, '*');
        });
    };

    useEffect(() => {
        sendPayloadData();
    }, [activeAccount, lang]);

    useEffect(() => {
        function handleMessage(messageEvent: MessageEvent<{ queryId: string; event: string }>) {
            if (!rawApp.openedApps?.find(({ homeUrl }) => homeUrl === messageEvent.origin)) return;
            const { event } = messageEvent.data;
            const sourceWindow = messageEvent.source as Window;

            switch (event) {
                case MessageEventsEnum.LISTEN_UPDATES:
                    sendPayloadData(sourceWindow);
                    break;
            }
        }

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);
};
